import styled from 'styled-components'
import { cyberColors } from '../../lib/colors'

export const BalanceWrapper = styled.p`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: ${cyberColors.greyText};
  text-transform: uppercase;
  width: 100%;
  text-align: left;
  margin-top: 10px;
`
